import React from 'react';
import SourceCitation from './SourceCitation';
import './MessageList.css';

const MessageList = ({ messages }) => {
  // Format timestamp
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  // Render message content with markdown-like formatting
  const renderContent = (content) => {
    // Simple line break support
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className="message-list">
      {messages.map((message) => (
        <div 
          key={message.id} 
          className={`message message-${message.role}`}
        >
          <div className="message-avatar">
            {message.role === 'user' ? '👤' : 
             message.role === 'assistant' ? '🤖' : 
             '📋'}
          </div>
          
          <div className="message-content-wrapper">
            <div className="message-header">
              <span className="message-sender">
                {message.role === 'user' ? 'You' : 
                 message.role === 'assistant' ? 'Legal Assistant' : 
                 'System'}
              </span>
              <span className="message-time">
                {formatTime(message.timestamp)}
              </span>
            </div>
            
            <div className={`message-content ${message.error ? 'error' : ''}`}>
              {renderContent(message.content)}
            </div>

            {/* Show source citations for assistant messages */}
            {message.role === 'assistant' && message.sources && message.sources.length > 0 && (
              <SourceCitation sources={message.sources} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageList;
